import { createFileRoute } from '@tanstack/react-router'

import { NodeLearners } from '@/licenses-tree/components/NodeLearners'

export const Route = createFileRoute(
  '/company/_management/licenses-structure/$nodeId/_panel/learners',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <NodeLearners />
}
